// Session/class locations: a configured site, or the hard-coded "Virtual" choice that is always in the dropdown.
export const VIRTUAL = "VIRTUAL";
export const VIRTUAL_LABEL = "Virtual";

const LEGACY = "legacy:";
export const legacyKey = (text) => `${LEGACY}${text}`;

export const isVirtual = (key) => key === VIRTUAL;

/** Display text for a location key: "Virtual", the site's name, or "" when nothing is chosen. */
export function locationText(key, sites = []) {
  if (isVirtual(key)) return VIRTUAL_LABEL;
  if (typeof key === "string" && key.startsWith(LEGACY)) return key.slice(LEGACY.length); // old free-text location kept as-is
  return sites.find((s) => String(s.id) === String(key))?.name || "";
}

/** The session fields a location key stands for. Virtual sessions carry the "Virtual" text. */
export function sessionLocationFields(key, sites = []) {
  return isVirtual(key)
    ? { location: VIRTUAL_LABEL, sessionType: "VIRTUAL" }
    : { location: locationText(key, sites) || undefined, sessionType: "PHYSICAL" };
}

/** Key for an existing session (site id, VIRTUAL, or "" when its text matches no configured site). */
export function keyForSession(session, sites = []) {
  if (session?.sessionType === "VIRTUAL" || session?.location === VIRTUAL_LABEL) return VIRTUAL;
  const site = sites.find((s) => s.name === session?.location);
  return site ? String(site.id) : "";
}
